// AUTO-GENERATED by scripts/compose-routes-plugin.ts. Do not edit.
import type { RouteObject } from "react-router-dom";
import routes_0 from "./features/_404/routes.partial";
import routes_1 from "./features/_smoke/routes.partial";
import routes_2 from "./features/admin/active-campaign/routes.partial";
import routes_3 from "./features/admin/admins/routes.partial";
import routes_4 from "./features/admin/alerts/routes.partial";
import routes_5 from "./features/admin/anomalies/routes.partial";
import routes_6 from "./features/admin/broker-currency/routes.partial";
import routes_7 from "./features/admin/gamification/routes.partial";
import routes_8 from "./features/admin/history/routes.partial";
import routes_9 from "./features/admin/integrations/routes.partial";
import routes_10 from "./features/admin/logs/routes.partial";
import routes_11 from "./features/admin/marketing/routes.partial";
import routes_12 from "./features/admin/matrix-webhooks/routes.partial";
import routes_13 from "./features/admin/news/routes.partial";
import routes_14 from "./features/admin/notifications/routes.partial";
import routes_15 from "./features/admin/payments/routes.partial";
import routes_16 from "./features/admin/payouts/routes.partial";
import routes_17 from "./features/admin/plans/routes.partial";
import routes_18 from "./features/admin/pwa/routes.partial";
import routes_19 from "./features/admin/refunds/routes.partial";
import routes_20 from "./features/admin/robot-analysis/routes.partial";
import routes_21 from "./features/admin/robot/routes.partial";
import routes_22 from "./features/admin/routes.partial";
import routes_23 from "./features/admin/stats/routes.partial";
import routes_24 from "./features/admin/subscriptions/routes.partial";
import routes_25 from "./features/admin/system/routes.partial";
import routes_26 from "./features/admin/test-mode/routes.partial";
import routes_27 from "./features/admin/trades/routes.partial";
import routes_28 from "./features/admin/users/routes.partial";
import routes_29 from "./features/admin/whatsapp/routes.partial";
import routes_30 from "./features/auth/routes.partial";
import routes_31 from "./features/checkout/routes.partial";
import routes_32 from "./features/currency-showcase/routes.partial";
import routes_33 from "./features/dashboard/routes.partial";
import routes_34 from "./features/gamification/routes.partial";
import routes_35 from "./features/matrix/routes.partial";
import routes_36 from "./features/preferences/routes.partial";
import routes_37 from "./features/prints/routes.partial";
import routes_38 from "./features/profile/routes.partial";
import routes_39 from "./features/refunds/routes.partial";
import routes_40 from "./features/robot/routes.partial";
import routes_41 from "./features/settings/routes.partial";
import routes_42 from "./features/trade/routes.partial";
import routes_43 from "./features/wallet/routes.partial";

export const generatedRoutes: RouteObject[] = [
  ...routes_0,
  ...routes_1,
  ...routes_2,
  ...routes_3,
  ...routes_4,
  ...routes_5,
  ...routes_6,
  ...routes_7,
  ...routes_8,
  ...routes_9,
  ...routes_10,
  ...routes_11,
  ...routes_12,
  ...routes_13,
  ...routes_14,
  ...routes_15,
  ...routes_16,
  ...routes_17,
  ...routes_18,
  ...routes_19,
  ...routes_20,
  ...routes_21,
  ...routes_22,
  ...routes_23,
  ...routes_24,
  ...routes_25,
  ...routes_26,
  ...routes_27,
  ...routes_28,
  ...routes_29,
  ...routes_30,
  ...routes_31,
  ...routes_32,
  ...routes_33,
  ...routes_34,
  ...routes_35,
  ...routes_36,
  ...routes_37,
  ...routes_38,
  ...routes_39,
  ...routes_40,
  ...routes_41,
  ...routes_42,
  ...routes_43,
];
